<template>
    <div class="my-4 d-flex flex-column align-items-center justify-content-center">
        <b-alert :show="!!errorHandlingMessage" variant="danger" dismissible>{{ errorHandlingMessage }}</b-alert>
        <div class="w-100">
            <div v-if="isActive">
                <div v-if="isEditable" class="">
                    <div v-if="hasDisplayForm" class="my-4 d-flex align-items-center justify-content-center"><!-- display form (read-only for now) -- if any! -->
                        <FormulateForm
                            ref="displayForm"
                            :name="`${nodeKey}-display-form`"
                            :debounce="100"
                            :values="displayFormInitialData"
                            :schema="displayFormSchema"
                            class="min-width-500"
                            :class="displayFormCssClasses"
                            @created="handleFormCreated"
                            @validation="handleFormValidation"
                            @blur="handleFormBlur"
                            @input="handleFormInput"
                            @submit="handleFormSubmit"
                        ></FormulateForm>
                    </div>
                    <div class="d-flex flex-column gap-4 align-items-center justify-content-around">  <!-- choice wrapper -->
                        <!-- TODO create/add ChoiceConfig to control layout of choices -->
                        <div v-if="availableChoiceObjects && availableChoiceObjects.length" class="d-flex gap-3 align-items-center min-width-500">
                            <hr class="flex-grow-1 w-100">
                            <span class="special-text text-muted text-nowrap">Select a choice below:</span>
                            <hr class="flex-grow-1 w-100">
                        </div>
                        <div 
                            v-for="choice in availableChoiceObjects" 
                            :key="choice.key" 
                            class="max-width-500 w-100"
                        >
                            <b-button 
                                block
                                variant="subtle-primary" 
                                class="px-5 py-3 text-left"
                                :disabled="choice.isDisabled"
                                @click="triggerChoice(choice)"
                            >
                                <div class="h5">{{ choice.label }}</div>
                                <div class="text-muted mb-0">{{ choice.description }}</div>
                            </b-button>
                        </div>
                    </div>
                </div>
                <div 
                    v-else
                    class="d-flex align-items-center justify-content-center min-height-200"
                >
                    <h5 class="text-muted">Waiting on assignees</h5>
                </div>
            </div>
            <div v-else-if="isCompleted" class="d-flex align-items-center justify-content-center min-height-200">
                <h5 class="text-muted">Task Completed</h5>
                <!-- add completed by -->
            </div>
            <div v-else-if="isWaiting" class="d-flex align-items-center justify-content-center min-height-200">
                <h5 class="text-muted">Waiting on other tasks</h5>
            </div>
        </div>
    </div>
</template>

<script>
import { errorHandling } from '../../js/custom-vue-mixins';
import FlowNodeContentMixin from './FlowNodeContentMixin';

export default {
    name: 'FlowNodeChoices',
    components: {},
    mixins: [
        errorHandling,
        FlowNodeContentMixin,
    ],
    props: {  // FROM MIXIN
        /* nodeData: {  
            type: Object,
            required: true,
        },
        nodeContext: {  // node-level context, with info/methods on calling transitions
            type: Object,
            required: true,  
        }, */
    },
    data() {
        return {
            errorMsg: 'Error',
            error: false,
        }
    },
    computed: {
        // LOTS OF COMPUTED PROPERTIES IN MIXIN, SEE FlowNodeContentMixin.js
        availableTriggers() {
            // all available triggers, for choice transitions or otherwise
            return (!!this.nodeContext.nodeTriggers && Array.isArray(this.nodeContext.nodeTriggers)) ? this.nodeContext.nodeTriggers : [];
        },
        choices() {
            // the array of choices, not necessarily the full transition
            // transtions (if available to the user viewing this) are in transitions
            // the 'key' from these are the names of the triggers
            return this.nodeData.choices ?? [];
        },
        availableChoiceObjects() {
            // the choice objects that are currently available -- this is what we show
            // if we want to HIDE all unavailable ones:
            //return this.choices.filter(ch => (this.availableTriggers.includes(ch.key)));
            // or if we only want to disable the buttons for unavailable ones:
            return this.choices.map(ch => {
                const modCh = {...ch};
                modCh['isDisabled'] = !this.availableTriggers.includes(ch.key);
                return modCh;
            });
        },
        // DISPLAY FORM (if any)
        // FORMS
        displayFormComponent() {
            return this.$refs['displayForm'] ?? null;
        },
        displayForm() {
            return this.nodeData?.display_form?.form ?? {};  // TODO - is this right?
        },
        hasDisplayForm() {
            return !!this.displayForm.key;
        },
        displayFormKey() {
            return this.displayForm.key ?? '';
        },
        displayFormSchema() {
            return this.displayForm.items ?? [];
        },
        displayFormInitialData() {
            return this.nodeData?.display_form?.data ?? {};
        },
        displayFormCssClasses() {
            return this.displayForm.css_classes || [];
        },
    },
    mounted() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        startApprove() {
            // complete it - call transition from parent passed down?
            this.nodeContext.startTransition(this.approveTriggerName);  // opens modal to confirm
        },
        startReject() {
            // complete it - call transition from parent passed down?
            this.nodeContext.startTransition(this.rejectTriggerName);  // opens modal to confirm
        },
        triggerChoice(choice) {
            // start trigger of a choice
            const triggerName = choice.key;
            this.nodeContext.startTransition(triggerName);  // opens modal to confirm
        },
        // display form handlers -- not actually needed for now...
        handleFormCreated(payload) {
            console.log('handleFormCreated', payload);
        },
        handleFormValidation(payload) {
            console.log('handleFormValidation', payload);
        },
        handleFormBlur(payload) {
            console.log('handleFormBlur', payload);
        },
        handleFormInput(payload) {
            console.log('handleFormInput', payload);
        },
        async handleFormSubmit(formData) {
            console.log('handleFormSubmit', formData);
        },
    }
}
</script>

<style>

</style>